import microuniversoApi from "app/api/microuniversoApi";
import store from "../../redux/store/store";
import {sobrescreverInformacoesAction} from "../../redux/orcamentoSlice";
import {ConfirmarNovaData} from "../../types/FinalizarOrcamento";
declare var window: any

export async function definirNovaDataCapacidadeCarga(dados: ConfirmarNovaData) {
    const orcamento = await microuniversoApi.Orcamento.definirNovaDataCapacidadeCarga(dados.FilialCapacidadeCargaEncaixe, dados.dataPrevisaoEntrega)
    const atualizarOrcamentoLegadoERedux = () => {
        const orcamentoLegado = window.orcamentoController.model
        orcamentoLegado.atualizar(orcamento)
        store.dispatch(sobrescreverInformacoesAction(orcamento))
    }


    atualizarOrcamentoLegadoERedux()
}
